;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();import type { SerializedTextNode } from "@payloadcms/richtext-lexical";
import type { JSXConverters } from "@payloadcms/richtext-lexical/react";
import type React from "react";
import { textStateConfig } from "@/fields/richText/textStateConfig";

const IS_BOLD = 1;
const IS_ITALIC = 2;
const IS_STRIKETHROUGH = 4;
const IS_UNDERLINE = 8;
const IS_CODE = 16;
const IS_SUBSCRIPT = 32;
const IS_SUPERSCRIPT = 64;

const NODE_STATE_KEY = "$";

function hyphenToCamel(str: string): string {
	return str.replace(/-([a-z])/g, (_, letter: string) => letter.toUpperCase());
}

function applyTextStateStyles(
	text: React.ReactNode,
	nodeState: Record<string, string> | undefined,
): React.ReactNode {
	if (!nodeState) return text;

	const styles: React.CSSProperties = {};
	for (const [stateKey, stateValue] of Object.entries(nodeState)) {
		const group = textStateConfig[stateKey as keyof typeof textStateConfig] as
			| Record<string, { css: Record<string, string> }>
			| undefined;
		const css = group?.[stateValue]?.css;
		if (!css) continue;
		for (const [prop, value] of Object.entries(css)) {
			(styles as Record<string, string>)[hyphenToCamel(prop)] = value;
		}
	}

	if (Object.keys(styles).length === 0) return text;
	return <span style={styles}>{text}</span>;
}

export const TextHTMLConverter: JSXConverters<SerializedTextNode> = {
	text: ({ node }) => {
		let text: React.ReactNode = node?.text;

		if (node.format & IS_BOLD) text = <strong>{text}</strong>;
		if (node.format & IS_ITALIC) text = <em>{text}</em>;
		if (node.format & IS_STRIKETHROUGH)
			text = <span style={{ textDecoration: "line-through" }}>{text}</span>;
		if (node.format & IS_UNDERLINE)
			text = <span style={{ textDecoration: "underline" }}>{text}</span>;
		if (node.format & IS_CODE) text = <code>{text}</code>;
		if (node.format & IS_SUBSCRIPT) text = <sub>{text}</sub>;
		if (node.format & IS_SUPERSCRIPT) text = <sup>{text}</sup>;

		text = applyTextStateStyles(
			text,
			(node as SerializedTextNode & { $?: Record<string, string> })[
				NODE_STATE_KEY
			],
		);

		return text;
	},
};
